import React, {useContext, useEffect, useRef, useState} from 'react';

function FirstLine(props) {
  const {children} = props;

  return (
    <div className="flex relative justify-between items-center w-full max-w-[1600px] mt-4 px-5 h-10 desktop:h-[43px] phone:gap-3 phone:mt-1.5">
      {children}
    </div>
  );
}

export default FirstLine;